import React, { Fragment } from "react";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
  Transition,
} from "@headlessui/react";

import { CheckIcon, ChevronDownIcon } from "components/Icons";
import FormField from "components/MeForm/FormField";
import upStore from "store/upStore";
import { classNames } from "tools/ui";

/**
 *
 * @param {*} props -
 * @param {Boolean} selection -
 * @param {String} name -
 * @param {String} label -
 * @param {String} value -
 * @param {Function} onChange -
 * @param {Boolean} required -
 * @param {Map} data_source -
 * @returns Component DropDown
 */

function MultiSelectionField(props) {
  const { field, attrs, data } = props;
  const { name } = field;
  const { level } = attrs;
  // props.data_source must be a Map()

  function selectedItem(selected) {
    // if (props.onChange) {
    //   props.onChange(props.name, data, data.recordid, data);
    // }
    // setSelectedOptions(data);
    data.value = selected;
    upStore(level, {
      fieldName: name,
      value: data.value,
      field: field,
    });
  }

  let options = field.options ?? [];
  if (props.data_source) {
    options = Array.from(props.data_source.values());
  }

  const selected_options = data.value && data.value !== "" ? data.value : [];
  console.log(options, "validate toptions");
  return (
    <FormField {...field}>
      <Listbox
        value={selected_options}
        onChange={(item) => selectedItem(item)}
        multiple
      >
        {({ open }) => (
          <div>
            <div className="relative mt-1">
              <ListboxButton className="relative w-full h-12 cursor-default rounded-md border border-gray-100 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:outline-none focus:border focus:border-cyan-500 sm:text-sm">
                {selected_options.map((option) => option.name).join(", ")}
                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                  <ChevronDownIcon
                    className="h-5 w-5 text-gray-400 fill-current"
                    aria-hidden="true"
                  />
                </span>
              </ListboxButton>

              <Transition
                show={open}
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <ListboxOptions className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-neutral-200 ring-opacity-5 focus:outline-none sm:text-sm">
                  {options.map((value) => (
                    <ListboxOption
                      key={value.id}
                      className={({ active }) =>
                        classNames(
                          active ? "text-white bg-cyan-500" : "text-gray-900",
                          "relative cursor-default select-none py-2 pl-8 pr-4",
                        )
                      }
                      value={value}
                    >
                      {({ selected, active }) => (
                        <div>
                          <span
                            className={classNames(
                              selected ? "font-semibold" : "font-normal",
                              "block truncate",
                            )}
                          >
                            {value.name}
                          </span>

                          {selected ? (
                            <span
                              className={classNames(
                                active ? "text-white" : "text-cyan-600",
                                "absolute inset-y-0 left-0 flex items-center pl-1.5",
                              )}
                            >
                              <CheckIcon
                                className="h-5 w-5 fill-current"
                                aria-hidden="true"
                              />
                            </span>
                          ) : null}
                        </div>
                      )}
                    </ListboxOption>
                  ))}
                </ListboxOptions>
              </Transition>
            </div>
          </div>
        )}
      </Listbox>
    </FormField>
  );
}

export default MultiSelectionField;
